import { createAction } from '@reduxjs/toolkit';

export const setAdminErrorStatus = createAction<'1' | '0' | undefined>('SET_ADMIN_ERROR_STATUS');

export const setAdminErrorsPage = createAction<number>('SET_ADMIN_ERRORS_PAGE');
